const SET_WATCH_FEATURED = 'WATCH/SET_WATCH_FEATURED'
const SET_NOW_SHOWING = 'WATCH/SET_NOW_SHOWING'
const SET_COMING_SOON = 'WATCH/SET_COMING_SOON'
const SET_MOVIE_MODAL_DATA = 'WATCH/SET_MOVIE_MODAL_DATA'
const SET_MOVIE_MODAL_STATUS = 'WATCH/SET_MOVIE_MODAL_STATUS'
const SET_TICKET_COUNT = 'WATCH/SET_TICKET_COUNT'
// TODO: add more action types if necessary

export {
  SET_WATCH_FEATURED,
  SET_NOW_SHOWING,
  SET_COMING_SOON,
  SET_MOVIE_MODAL_DATA,
  SET_MOVIE_MODAL_STATUS,
  SET_TICKET_COUNT,
  // TODO: export action types added later
}
